import Utility from '../../../src/core/Utility.js';

/* For IE11(#2729) */
class WidgetDataSourceController {
	constructor($scope, $element, serviceWorkerLogdb, $timeout) {
		this.scope = $scope;
		this.el = $element;
		this.$timeout = $timeout;

		this.elInput = this.el.find('query-input')[0];
		this.elModal = this.el[0];

		this.serviceWorkerLogdb = serviceWorkerLogdb;

		this.isOnSubmit = false;
		this.queryResult = [];
		this.dataFields = [];
		this.currentDataSource = {};
		this.columnInfo = [];

		this.onStarted = () => {};
		this.selectedSource = null;

		this.scope.$on('WidgetDataController:openDataSourceModal', (event, params, selectedSource) => {
			this.openDataSourceModal(params, selectedSource);
		});
	}

	queryChanged(){
		this.isQueryChanged = true;
	}

	clearModal() {
		this.isQueryChanged = false;
		if(this.currentDataSource.guid === 'NEW_DATASOURCE'){
			this.isQueryChanged = true;
		}
		this.isOnSubmit = false;
		this.queryResult = [];
		this.dataFields = [];
		this.selectedSource = null;;
	}

	openDataSourceModal(datasource = {name: '', guid: 'NEW_DATASOURCE'} , selectedSource) {
		this.selectedSource = selectedSource;
		this.currentDataSource = {
			name: datasource.name,
			guid: datasource.guid,
			query: datasource.query
		};
		this.clearModal();
		if(!!this.currentDataSource.query){
			this.$timeout(function() {
				this.elInput.run(this.currentDataSource.query);
			}.bind(this));
		} else {
			this.$timeout(function() {
				this.elInput.setPristine();
			}.bind(this));
		}
		this.elModal.showDialog();
	}

	validateForAdd() {
		if(!this.currentDataSource.name || !this.currentDataSource.query || this.isQueryChanged) {
			this.isOnSubmit = true;
			return;
		}
		this.elInput.run(this.currentDataSource.query);
		//setTimeout(this.elInput.run, 10);

		this.onStarted = () => {
			this.elInput.dispose();
			this.setDataSource();

			this.elModal.hideDialog();
			this.onStarted = () => {};
		};
	}

	onTail(helper) {
		const instance = this.elInput.getInstance();
		instance.getResult(0, 100, resp => {
			this.isQueryChanged = false;
			this.queryResult = resp.body.result;
			this.dataFields = resp.body.field_order;
			//added in issue2513
			// this.columnInfo = resp.body.field_types;
			this.serviceWorkerLogdb.data.getColumnType(resp.body.field_types, types => {
				this.columnInfo = types;
				this.scope.$apply();
			});
			// this.serviceWorkerLogdb.data.getColumnType(this.queryResult, types => {
			// 	this.columnInfo = types;
			// 	this.scope.$apply();
			// });
		});
	}

	onChangeHandler() {
		// 데이터소스가 변경되면 부모 프리셋을 저장해야하는데, 이를 위해 scope 간 통신
		this.scope.$emit('DashboardContainerController:onDataSourceChange', this.scope.store);
	}

	onDatasourceChanged(){
		this.scope.$emit('WidgetDataController:onDataSourceChange');	
	}

	setDataSource() {
		if(this.currentDataSource.guid === 'NEW_DATASOURCE') {
			this.currentDataSource['guid'] = Utility.generateType1();
			this.scope.store.createSource(this.currentDataSource);
		}
		else {
			const datasource = this.scope.store.sources[this.currentDataSource.guid];
			datasource.update(this.currentDataSource.name, this.currentDataSource.query);
			if(!!this.selectedSource && (this.currentDataSource.guid == this.selectedSource.guid)){
				this.onDatasourceChanged();
			}
		}

		this.onChangeHandler();

		this.scope.$apply();
	}

	onFailed() {
		if(!this.onStarted.name) {
			notify('danger', '실행할 수 없는 쿼리입니다.', true);
		}
		else {
			// 추가할때 실패할 경우
			notify('danger', '데이터소스를 추가 할 수 없습니다. 실행할 수 없는 쿼리입니다.', true);
		}
	}
}

WidgetDataSourceController.$inject = ['$scope', '$element', 'serviceWorkerLogdb', '$timeout'];

export default WidgetDataSourceController;


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/dashboard/WidgetDataSourceController.js